// React action builder — opens the emoji picker anchored to the button.
//
// The picker itself lives in the host row so its open/close state
// travels with the row, not with the action list. This builder only
// exposes the ARIA relationship (`aria-haspopup="dialog"`,
// `aria-expanded`) and a `buttonRef` for anchoring.

import type { Ref } from "react";
import { Smile } from "lucide-react";

import type { MessageAction } from "~/components/MessageActions";

export function buildReactAction(params: {
  pickerOpen: boolean;
  onToggle: () => void;
  buttonRef?: Ref<HTMLButtonElement>;
  disabled?: boolean;
}): MessageAction {
  return {
    id: "react",
    label: "React",
    icon: Smile,
    onClick: params.onToggle,
    hasPopup: "dialog",
    expanded: params.pickerOpen,
    buttonRef: params.buttonRef,
    disabled: params.disabled,
  };
}
